import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import StatsAPI from "@/src/api/StatsAPI";

import { contentViewsGraphQuery } from "./contentItem.queries";
import { buildContentViewsGraphTimeline } from "./contentItem.utils";
import ExportCsvButton from "../charts/ExportCsvButton";
import TimelineQueryCard from "../charts/TimelineQueryCard";

import type { JSX } from "react";

import type { ContentItemPeriodProps } from "./contentItem.types";
import type { ChartSeries, ViewsSeriesKey } from "../charts/charts.types";

function ContentViewsCard({
  contentId,
  period,
}: ContentItemPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<ViewsSeriesKey>[] => [
      {
        key: "views",
        label: t("charts.series.views"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const fetchCsv = async (): Promise<BlobPart> =>
    StatsAPI.getContentViewsGraph({
      contentId,
      projectSlug,
      startDate: period.startDate,
      endDate: period.endDate,
      isExport: true,
    });

  return (
    <TimelineQueryCard
      buildTimeline={buildContentViewsGraphTimeline}
      endDate={period.endDate}
      query={contentViewsGraphQuery(projectSlug, contentId, period)}
      seriesList={seriesList}
      startDate={period.startDate}
      title={t("contentItem.charts.views")}
      extraActions={
        <ExportCsvButton fetchCsv={fetchCsv} fileName="views.csv" />
      }
    />
  );
}

export default ContentViewsCard;
